import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BackArrowMenu from "../../UI/BackArrowMenu";
import VerticalMenu from "../../UI/VerticalMenu";
import { ClassificationEnum } from "../../../models/ClassificationContentBankEnum";
import FilterContentBank from "./FilterAPI/FilterContentBank";
import classes from './TypeMenuContentBank.module.css'
import { onKeyDown } from "../../../service";

const TypeMenuContentBank = ({ handleChange, listFilter, setCurrent, current, fromPopup,selected}) => {

    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector((state) => state.application.homeUrl);
    const navigate = useNavigate();

    useEffect(() => {
        if (!fromPopup) {
            handleChange("classificationId", ClassificationEnum[listFilter[current].name])
        }
    }, [current])

    useEffect(() => {
        if (fromPopup) {
            if (fromPopup === ClassificationEnum.lesson) {
                setCurrent(2)
            }
            handleChange("classificationId", fromPopup)
        }
    }, [])
    return (
        <>
            {!fromPopup ? <BackArrowMenu title={texts.homePage} description={""} onClick={() => navigate(`${homeUrl}`)} /> : <div className={classes.EmptyBackArrowMenu} />}
            <VerticalMenu currentIndex={current}>
                {listFilter && listFilter.map((c, index) =>
                    <div key={index} title={texts[c.name]} onClick={() => setCurrent(index)} disable={c.disable} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setCurrent(index))}>
                        {Object.keys(c.filters).map(f =>
                            <FilterContentBank key={f} type={c.filters[f].type} handleChange={(value) => handleChange(f, value)} list={c.filters[f].list} text={c.filters[f].title} hideClear={c.filters[f].hideClear} selected={selected} />
                        )}
                    </div>
                )}
            </VerticalMenu >
        </>


    )
}

export default TypeMenuContentBank;